/**
 * index.js contains the logic to expose the component, in this case it simply exposes
 * the MfContainer component.
 */
import MfContainer from './MfContainer.component';

export default MfContainer;
